import { ToastActionElement } from "@shared/src/components/ui/toast";
import { OrderTypeKey } from "@sdk/shared/types/order.types";
import { AuthParams } from "@shared/src/hooks/auth/types";
import { toast, dispatch } from "@shared/src/hooks/use-toast";
import { useHostStore } from "@shared/src/stores/useHostStore";

// Re-export toast helper so downstream packages can `import { toast } from "@shared/src/utils"`.
export { toast, type ToastActionElement };

// Generate a consistent color based on string
export function generateColorFromString(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = hash % 360;
  const s = 70;
  const l = 50;
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export const getErrorMessage = (message: string | React.ReactNode | object | Error): string => {
  let errorMessage = "";
    console.log("gettingErrorMessage message", message);

  if (message === undefined) return "";
  try {
    if (typeof message === "string") {
      errorMessage = message;
    } else if (message instanceof Error || (typeof message === "object" && message !== null && "message" in message)) {
      errorMessage = message.message as string;
    } else {
      errorMessage = JSON.stringify(message);
    }
  } catch (e) {
    console.log("error in modal-->:", e);
    return "An error occurred. Please try again later";
  }
  console.error({ errorMessage, message });

  if (errorMessage.includes("User rejected the request")) {
    return "You rejected the request";
  }
  if (errorMessage.includes("0xe450d38c")) {
    return "Insufficient ERC20 Token Balance. Please top up your balance";
  }
  if (errorMessage.includes("ERC20InsufficientBalance")) {
    return "Insufficient Token Balance. Please top up your balance";
  }
  if (errorMessage.includes("0xfb8f41b2")) {
    return "Insufficient Allowance.";
  }
  if (errorMessage.includes("sender balance and deposit together")) {
    return "Insufficient funds for gas. Please get some gas tokens from faucet.";
  }
  if (errorMessage.includes("gas required exceeds allowance")) {
    return "Insufficient ETH for gas fees. Add a small amount of ETH to your wallet on this network to pay transaction fees.";
  }
  if (errorMessage.includes("SignatureExpired")) {
    return "Signature expired. Please try again";
  }
  if (errorMessage.includes("Modal closed")) {
    return "";
  }
  if (errorMessage.includes("User denied transaction signature")) {
    return "You denied the transaction signature";
  }
  if (
    errorMessage.includes(
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.",
    )
  ) {
    return "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.";
  }

  return errorMessage;
};



export function checkIfMerchant(merchantAddress: string) {
  const { sdk } = useHostStore.getState();
  const activeAddress = sdk?.auth.getAddress()?.toLowerCase();
  console.log("checkIfMerchant", { activeAddress, merchantAddress });
  if (activeAddress) return activeAddress === merchantAddress.toLowerCase();
  else return undefined;
}

export function getTradeRoles(merchantAddress: string, orderOrAdType: OrderTypeKey) {
  const isMerchant = checkIfMerchant(merchantAddress);
  const isBuyer = (isMerchant && orderOrAdType === "sell") || (!isMerchant && orderOrAdType === "buy");
  const isSeller = (isMerchant && orderOrAdType === "buy") || (!isMerchant && orderOrAdType === "sell");
  const tradeType = isMerchant ? swap[orderOrAdType] : orderOrAdType;
  console.log("getTradeRoles", { isMerchant, isBuyer, isSeller, tradeType });
  return { isMerchant, isBuyer, isSeller, tradeType };
}

export function getTradeType(orderType: OrderTypeKey, merchantAddress: string) {
  const isMerchant = checkIfMerchant(merchantAddress);
  const tradeType = isMerchant ? swap[orderType] : orderType;
  return { tradeType, isMerchant };
}

export const swap = { buy: "sell", sell: "buy" } as const;

export function getWalletTypefromParams(params: AuthParams) {
  return params.type === "wallet" || params.type === "walletConnect" ? "eoa" : "sca";
}

// -------------------------------------------------------------------
// Temporary re-export of shared-components helper utilities until all
// modules are migrated to rely directly on the shared package.
// -------------------------------------------------------------------
